import api from "@/api/apiConfig"
import {
  Post,
  Get
} from './base/baseAjax'
let getSystem = (param) => {
  return Get({
    url: api.permission.getSystem,
    PathParam: param
  })
}
let getPermission = (param) => {
  return Get({
    url: api.permission.getPermission,
    UrlParam: param
  })
}
let getPermissionType = (param) => {
  return Get({
    url: api.permission.getPermissionType,
    PathParam: param
  })
}
let getPermissionData = (param) => {
  return Post({
    url: api.permission.getPermissionData,
    UrlParam: param
  })
}
let setMenusPermission = (param) => {
  return Post({
    url: api.permission.setMenusPermission,
    bodyParam: param
  })
}
let setDataPermission = (param) => {
  return Post({
    url: api.permission.setDataPermission,
    bodyParam: param
  })
}
let setAppPermission = (param) => {
  return Post({
    url: api.permission.setAppPermission,
    bodyParam: param
  })
}
let setOrganPermission = (param) => {
  return Post({
    url: api.permission.setOrganPermission,
    bodyParam: param
  })
}
// 旧版权限同步接口，对原有权限做增量更新
let syncPost = (param) => {
  return Post({
    url: api.permission.syncPost,
    bodyParam: param
  })
}
// 新版权限同步接口，完全替换原有权限
let syncPost2 = (param) =>{
  return Post({
    url: api.permission.syncPost2,
    bodyParam: param
  })
}

export default {
  getSystem,
  getPermission,
  getPermissionType,
  getPermissionData,
  setMenusPermission,
  setDataPermission,
  setAppPermission,
  setOrganPermission,
  syncPost,
  syncPost2
}



// WEBPACK FOOTER //
// ./src/services/permission.js